// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"LineWrapper_text-gradient__1hPuk","chartWrapper":"LineWrapper_chartWrapper__1iOgv"};